'use client';

import { useMotionTemplate, useSpring, useTransform, useVelocity } from 'motion/react';

import {
  animate,
  AnimatePresence,
  LayoutGroup,
  LazyMotion,
  motion,
  Reorder,
  type AnimationPlaybackControls,
  type Variants,
} from 'framer-motion';

export {
  animate,
  AnimatePresence,
  LayoutGroup,
  LazyMotion,
  motion,
  Reorder,
  useMotionTemplate,
  useSpring,
  useTransform,
  useVelocity,
  type AnimationPlaybackControls,
  type Variants,
};
